import { render, staticRenderFns } from "./Attori.vue?vue&type=template&id=746c7d75&"
import script from "./Attori.vue?vue&type=script&lang=ts&"
export * from "./Attori.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports